<template>
  <v-navigation-drawer
    v-model="show" app right clipped width="440" disable-resize-watcher>
    <div>
      <v-toolbar flat color="primary" dark>
        <v-icon>mdi-account-multiple</v-icon>
        <v-toolbar-title class="text-truncate">{{ roomName }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon @click.stop="show = !show" v-on="on" small>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('confr.tooltip.close') }}</span>
        </v-tooltip>
      </v-toolbar>
      <v-list>
        <template v-for="(member, idx) in activeRoom.members">
          <Member :member="member"
            @kick-member="kickConfirm(member)"
            @mute-member="mute(member)"
            :key="`${idx}-member`"/>
        </template>
      </v-list>

      <v-dialog v-model="confirmKick" persistent max-width="400px">
        <v-card>
          <v-card-title>{{ $t('confr.kickDlg.title') }}</v-card-title>
          <v-card-text>
            {{ $t('confr.kickDlg.msg',
              { num: memToKick ? memToKick.num : '',
                name: memToKick ? memToKick.name : '',
                conf: activeRoom ? activeRoom.name : '' })
            }}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="kickDlgClose" text>{{ $t('confr.kickDlg.cancel') }}</v-btn>
            <v-btn @click="kickMember" text>{{ $t('confr.kickDlg.ok') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Member from './member'
import * as RMQClient from '@/rmqclient'

export default {
  name: 'conference-members',
  data () {
    return {
      confirmKick: false,
      memToKick: null
    }
  },
  computed: {
    ...mapGetters({
      showPane: 'conferences/memPaneShow',
      activeRoom: 'conferences/activeRoom'
    }),
    roomName: function () {
      return this.activeRoom.name
    },
    show: {
      get: function () {
        return this.activeRoom?.members?.length > 0
      },
      set: function (val) {
        if (!val) {
          this.setActive(null)
        }
        this.setPaneShow(val)
      }
    }
  },
  components: { Member },
  methods: {
    ...mapActions({
      setPaneShow: 'conferences/memPaneShow',
      setActive: 'conferences/setActive'
    }),
    mute: function (member) {
      const action = member.muted
        ? 'ConfbridgeUnmute'
        : 'ConfbridgeMute'
      RMQClient.sendCmd({
        action: action,
        conference: this.activeRoom.confno,
        channel: member.channel
      })
    },
    kickConfirm: function (member) {
      this.memToKick = member
      this.confirmKick = true
    },
    kickMember: function () {
      const chan = this.memToKick.channel
      RMQClient.sendCmd({
        action: 'ConfbridgeKick',
        conference: this.activeRoom.confno,
        channel: chan
      })
      this.kickDlgClose()
    },
    kickDlgClose: function () {
      this.confirmKick = false
      this.memToKick = null
    }
  }
}
</script>

<style scoped>
</style>
